import { default as icons } from './components/Icon/iconNames';
export default {
  icons: icons
};